/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const menu = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M5 5.5V7h14V5.5H5zM5 13h14v-1.5H5V13zm0 6h14v-1.5H5V19z" />
	</SVG>
);

export default menu;
